/**
 * A narração dos tutoriais: a mesma voz dos tutoriais do Infinity.
 *
 * Cada fala é gerada UMA vez (`scripts/voz-tutoriais/`) e vira arquivo
 * estático em `public/voz-dos-tutoriais`. O manifesto indexa a fala pelo hash
 * de voz + jeito de falar + TEXTO: mudou o texto do balão, o hash muda e o
 * passo fica mudo até alguém gerar de novo; nunca toca o áudio velho de um
 * texto novo. O teste da voz reprova enquanto faltar fala.
 *
 * A pasta não pode ter o nome de uma rota do app: no Infinity, a pasta
 * `public/tutoriais` fez o servidor achar o diretório antes do app e a rota
 * de mesmo nome passou a responder 403.
 */
export const VOZ = 'gemini-2.5-pro-tts:Puck';
export const JEITO_DE_FALAR =
  'Fale em português do Brasil com energia e um sorriso na voz, como alguém animado em mostrar uma novidade útil, mas sem exagero e sem soar como locutor.';
export const PASTA_DA_VOZ = 'voz-dos-tutoriais';

/** O que o passo fala: a `fala`, quando o texto escrito não serve para ser lido em voz alta. */
export const textoFalado = (passo) => (passo.fala ?? passo.texto).trim();

/**
 * FNV-1a de 32 bits: não é segurança, é a chave que amarra o áudio ao texto
 * exato (a mesma conta do Infinity). O script de geração usa esta função.
 */
export const hashDaFala = (texto) => {
  const chave = `${VOZ}|${JEITO_DE_FALAR}|${texto.trim()}`;
  let hash = 0x811c9dc5;
  for (let i = 0; i < chave.length; i += 1) {
    hash ^= chave.charCodeAt(i);
    hash = Math.imul(hash, 0x01000193);
  }
  return (hash >>> 0).toString(16).padStart(8, '0');
};

export const urlDaVoz = (arquivo) => `${process.env.PUBLIC_URL || ''}/${PASTA_DA_VOZ}/${arquivo}`;

let manifesto = null;

/**
 * Baixa o manifesto uma vez por sessão. Falhou (rede, arquivo ausente)? O
 * tutorial segue só com texto, e a próxima fala tenta de novo.
 */
export const carregarManifesto = () => {
  if (typeof fetch !== 'function') return Promise.resolve(null);
  manifesto ??= fetch(urlDaVoz('manifesto.json'))
    .then((resposta) => (resposta.ok ? resposta.json() : null))
    .catch(() => null)
    .then((lido) => {
      if (!lido) manifesto = null;
      return lido;
    });
  return manifesto;
};
